import React from "react";

const AnnualMaskPressureNotice = ({ certificate }) => {
  const review = certificate && certificate.pressureReview;
  if (!review || review.status === "unchanged") return null;
  return (
    <div className="alert alert-warning py-2 px-3 mb-2 small" role="note">
      {review.status === "changed" ? (
        <>
          Pressure changed in the signed medical certificate: {review.original.minPressure}–{review.original.maxPressure}
          {" → "}{review.signed.minPressure}–{review.signed.maxPressure} cmH₂O.
          {" "}Review the signed certificate for this batch.
        </>
      ) : (
        <>Pressure comparison skipped because the pressure or original setting could not be read. You can continue with this signed certificate.</>
      )}
    </div>
  );
};

export default AnnualMaskPressureNotice;
